<template>
  <div>
    <ts-card>
      <div class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative">
        <h4 class="ts-text-sm">{{ $t('employeeStatusReason.pageTitle') }}</h4>
        <ts-modal-close-button />
      </div>
      <ts-card-wrapper>
        <div class="row form-group">
          <div class="col-md-12">
            <label class="required">{{$t('employeeStatusReason.status')}}</label>
            <treeselect
              :options="options"
              :load-options="loadOptions"
              :placeholder="$t('select')"
              v-model="model.status_id"
            />
            <div class="text-danger" v-if="errors.has('status_id')">{{ errors.first('status_id') }}</div>
          </div>
        </div>
        <div class="row form-group">
          <div class="col-md-12">
            <label class="required">{{$t('employeeStatusReason.reason')}}</label>
            <textarea
              rows="2"
              class="form-control"
              :class="{'is-invalid': errors.has('reason')}"
              v-model="model.reason"
            ></textarea>
            <div
              class="invalid-feedback"
              v-if="errors.has('status_id')"
            >{{ errors.first('status_id') }}</div>
          </div>
        </div>
        <div class="row form-group">
          <div class="col-md-12">
            <ts-checkbox v-model="model.is_paid">{{$t('employeeStatusReason.isPaid')}}</ts-checkbox>
          </div>
        </div>
        <div class="row ts-mt-6">
          <div class="col-sm-12 col-lg-12 col-md-12 text-right">
            <ts-button @click.prevent="$emit('close')" :disabled="saving">{{ $t('button.cancel') }}</ts-button>
            <ts-button
              v-if="!editData"
              color="primary"
							outline
              class="ml-2"
              :waiting="saving_new"
              @click.prevent="saveNew"
            >
              {{
              $t('button.saveAddNew')
              }}
            </ts-button>
            <ts-button
              v-if="!editData"
              color="primary"
              class="ml-2"
              :waiting="saving"
              @click.prevent="save"
            >
              {{
              $t('button.save')
              }}
            </ts-button>
            <ts-button
              v-if="editData"
              color="primary"
              class="ml-2"
              :waiting="updating"
              @click.prevent="updateRecord"
            >
              {{
              $t('button.update')
              }}
            </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { LOAD_ROOT_OPTIONS } from '@riophae/vue-treeselect'
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'

export default {
  name: 'employeeStatusReasonForm',
  props: ['editData'],
  data() {
    return {
      model: {
        status_reason_id: 0,
        status_id: null,
        reason: null,
        is_paid: false
      },
      saving: false,
      saving_new: false,
      updating: false,
      options: null,
      errors: new Errors()
    }
  },
  created() {
    this.setEditData()
  },
  methods: {
    ...mapActions('hr/employeeStatusReason', ['store', 'update']),
    saveNew() {
      this.errors = new Errors()
      this.saving_new = true
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.saving_new = false
        })
    },
    save() {
      this.errors = new Errors()
      this.saving = true
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('close')
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.saving = false
        })
    },
    updateRecord() {
      this.errors = new Errors()
      this.updating = true
      this.update({
        id: this.model.status_reason_id,
        data: this.model
      })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('close')
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.updating = false
        })
    },
    clearInput() {
      this.errors = new Errors()
      this.model = {
				status_reason_id: 0,
        status_id: null,
        reason: null,
        is_paid: false
      }
    },
    setEditData() {
      if (!_.isEmpty(this.editData) && this.editData != undefined) {
        this.model = {
					status_reason_id: this.editData.status_reason_id,
          status_id: this.editData.status_id,
          reason: this.editData.reason,
          is_paid: this.editData.is_paid
        }
      }
    },
    async loadOptions({ action /*, callback*/ }) {
      if (action === LOAD_ROOT_OPTIONS) {
        let response = await this.$store.dispatch('hr/employeeStatusReason/getEmployeeStatus',{
					filter: {
						status_id: '2,3'
					}
				})
        this.options = response.data.map(el => ({
          id: el.status_id,
          label: el.status
        }))
      }
    }
  }
}
</script>